const get = require(`lodash/get`)

const componentEnPaths = {
  'component---src-pages-recherche-tsx': `search`,
  'component---src-pages-signature-courriel-tsx': `email-signature`,
  'component---src-pages-aws-formation-certification-tsx': `aws-training-certification`,
  'component---src-pages-gestion-de-projet-tsx': `project-management`,
  'component---src-pages-programmes-developpement-leadership-tsx': `leadership-development-programs`,
  'component---src-pages-programmes-tsx': `programs`,
  'component---src-pages-cercles-tsx': `circles`,
  'component---src-pages-coaching-professionnel-tsx': `professional-coaching`,
  'component---src-pages-organisations-tsx': `organizations`,
  'component---src-pages-infolettre-tsx': `newsletter`,
  'component---src-pages-vivre-afiu-tsx': `afiu-experience`,
}

const pagePathFactory = (locale, node) => {
  let sectionSlug = get(node, [`section`, `slug`, locale, `current`], ``)
  if (sectionSlug) sectionSlug += `/`
  return `/${locale}/${sectionSlug}${node.slug[locale].current}`
}

const MSFT_ESI_SLUG = `microsoft-enterprise-skills-initiative`

module.exports = {
  en: {
    aboutUsPath: '/en/about/about-us',
    homePath: `/en`,
    blogPath: `/en/resources/publications`,
    blogPathFactory: (slug) => `/en/publications/${slug}`,
    careersPath: `/en/about/careers`,
    catalogPath: `/en/training/catalog`,
    catalogResetFiltersPath: `/en/training/catalog?reset=true`,
    humanCatalogPath: `/en/training/catalog/human`,
    digitalToolsCatalogPath: `/en/training/catalog/technology/desktop-applications`,
    technologiesCatalogPath: `/en/training/catalog/technology`,
    dataScienceCatalogPath: `/en/training/catalog/technology/data-management`,
    organizationalStrategyCatalogPath: `/en/training/catalog/strategy-operations`,
    projectManagementCatalogPath: `/en/training/catalog/strategy-operations/project-management`,
    catalogGuaranteedSessionsPath: '/en/training/catalog?SessionsConfirmed=true',
    circlesPath: `/en/circles`,
    confidentialityPath: `/en/confidentiality`,
    faqPath: `/en/about/faq`,
    fundingPath: `/en/solutions/funding`,
    htmlLang: `en`,
    locale: `en-CA`,
    masterClassPathFactory: (slug) => `/en/masterclass/${slug}`,
    microprogramPathFactory: (slug) => `/en/microprograms/${slug}`,
    microsoftEsiIndexSlug: `develop-your-azure-cloud-skills-and-knowledge`,
    microsoftEsiPathFactory: (slug) => `/en/${MSFT_ESI_SLUG}/${slug}`,
    newsletterPath: `/en/newsletter`,
    ogLang: `en_CA`,
    organizationsPath: `/en/organizations`,
    organizationGroupsPath: `/en/organizations#groupes`,
    organizationWorkshopsPath: `/en/organizations#ateliers`,
    organizationCoachingPath: `/en/organizations#coaching`,
    organizationProgramsPath: `/en/organizations#programmes`,
    organizationConferencesPath: `https://lp.afiexpertise.com/conferences-afi-u`,
    ourOfficesPath: `/en/a-propos/nouveaux-bureaux`,
    packagesPromotionsPath: `/en/solutions/packages-promotions`,
    pagePathFactory: (node) => pagePathFactory(`en`, node),
    partnersCertificationsPath: `/en/about/partners-certifications`,
    path: `en`,
    pathFactory: (slug) => `/en/${slug}`,
    programPathFactory: (slug) => `/en/programs/${slug}`,
    programsPath: `/en/programs`,
    publicationIndexPath: `/en/resources/publications/`,
    publicationPathFactory: (slug) => `/en/publications/${slug}`,
    safireKey: `English`,
    teamPath: `/en/a-propos/equipe-et-formateurs`,
    themePathFactory: (slug) => `/en/themes/${slug}`,
    themesPath: `/en/themes/training-and-coaching`,
    themeCoachingPath: `/en/themes/coaching`,
    themeBusinessOperationsPath: `/en/themes/business-operations`,
    themeDataIntelligencePath: `/en/themes/data-intelligence`,
    themeStrategyPath: `/en/themes/strategy`,
    themeAdoptionDigitalPath: `/en/themes/adopting-digital-tools`,
    themeFutureOfWorkPath: `/en/themes/future-of-work`,
    themeLeadershipPath: `/en/themes/leadership`,
    themeDigitalTransformationPath: `/en/themes/digital-transformation`,
    title: `English`,
    trainerPathFactory: (slug) => `/en/trainers/${slug}`,
    trainingPathFactory: (slug) => `/en/training/${slug}`,
    microsoftTrainingPath: `/en/training/catalog/microsoft`,
    awsTrainingPath: `/en/training/catalog/aws`,
    icfTrainingPath: `/en/professional-coaching`,
    pmiTrainingPath: `/en/training/catalog/strategy-operations/project-management`,
    leanTrainingPath: `/en/training/catalog/strategy-operations/lean-methodology`,
    comptiaTrainingPath: `/en/training/catalog/comptia`,
    vmwareTrainingPath: `/en/training/catalog/vmware`,
    ciscoTrainingPath: `/en/training/catalog/cisco`,
    itilTrainingPath: `/en/training/catalog/itil`,
    scaleTrainingPath: `/en/training/catalog/scale-agile`,
    specialOfferPathFactory: (brand) => `/en/offer/${brand}`,
    specialOfferCoursePathFactory: (brand, slug) => `/en/offer/${brand}/course/${slug}`,
    vivreAfiUPath: `/en/afiu-experience`,
    ...componentEnPaths,

    contactPath: `https://lp.afiexpertise.com/contact-us-afiu`,
  },
  fr: {
    aboutUsPath: '/fr/a-propos/qui-sommes-nous',
    homePath: `/fr`,
    blogPath: `/fr/ressources/publications`,
    blogPathFactory: (slug) => `/fr/publications/${slug}`,
    careersPath: `/fr/a-propos/carrieres`,
    catalogPath: `/fr/formation/catalogue`,
    catalogResetFiltersPath: `/fr/formation/catalogue?reset=true`,
    humanCatalogPath: `/fr/formation/catalogue/humain`,
    digitalToolsCatalogPath: `/fr/formation/catalogue/technologies/outils-bureautique`,
    technologiesCatalogPath: `/fr/formation/catalogue/technologies`,
    dataScienceCatalogPath: `/fr/formation/catalogue/technologies/gestion-des-donnees`,
    organizationalStrategyCatalogPath: `/fr/formation/catalogue/strategie-operations`,
    projectManagementCatalogPath: `/fr/formation/catalogue/strategie-operations/gestion-de-projet`,
    catalogGuaranteedSessionsPath: '/fr/formation/catalogue?SessionsConfirmed=true',
    circlesPath: `/fr/cercles`,
    confidentialityPath: `/fr/confidentialite`,
    default: true,
    faqPath: `/fr/a-propos/faq`,
    fundingPath: `/fr/solutions/programmes`,
    htmlLang: `fr`,
    locale: `fr-CA`,
    masterClassPathFactory: (slug) => `/fr/masterclass/${slug}`,
    microprogramPathFactory: (slug) => `/fr/microprogrammes/${slug}`,
    microsoftEsiIndexSlug: `developpez-vos-competences-et-vos-connaissances-du-cloud-azure`,
    microsoftEsiPathFactory: (slug) => `/fr/${MSFT_ESI_SLUG}/${slug}`,
    newsletterPath: `/fr/infolettre`,
    ogLang: `fr_CA`,
    organizationsPath: `/fr/organisations`,
    organizationGroupsPath: `/fr/organisations#groupes`,
    organizationWorkshopsPath: `/fr/organisations#ateliers`,
    organizationCoachingPath: `/fr/organisations#coaching`,
    organizationProgramsPath: `/fr/organisations#programmes`,
    ourOfficesPath: `/fr/a-propos/nouveaux-bureaux`,
    packagesPromotionsPath: `/fr/solutions/forfaits-promotions`,
    pagePathFactory: (node) => pagePathFactory(`fr`, node),
    partnersCertificationsPath: `/fr/a-propos/partenaires-certifications`,
    path: `fr`,
    pathFactory: (slug) => `/fr/${slug}`,
    programPathFactory: (slug) => `/fr/programmes/${slug}`,
    programsPath: `/fr/programmes`,
    publicationIndexPath: `/fr/ressources/publications/`,
    publicationPathFactory: (slug) => `/fr/publications/${slug}`,
    safireKey: `French`,
    specialOfferCoursePathFactory: (brand, slug) => `/fr/offre/${brand}/formation/${slug}`,
    specialOfferPathFactory: (brand) => `/fr/offre/${brand}`,
    teamPath: `/fr/a-propos/equipe-et-formateurs`,
    themePathFactory: (slug) => `/fr/thematiques/${slug}`,
    themesPath: `/fr/thematiques/apprentissage-et-coaching`,
    themeCoachingPath: `/fr/thematiques/coaching`,
    themeBusinessOperationsPath: `/fr/thematiques/gestion-des-operations`,
    themeDataIntelligencePath: `/fr/thematiques/intelligence-des-donnees`,
    themeStrategyPath: `/fr/thematiques/gestion-strategique`,
    themeAdoptionDigitalPath: `/fr/thematiques/adoption-des-outils-numeriques`,
    themeFutureOfWorkPath: `/fr/thematiques/futur-du-travail`,
    themeLeadershipPath: `/fr/thematiques/leadership`,
    themeDigitalTransformationPath: `/fr/thematiques/transformation-numerique`,
    title: `Français`,
    trainerPathFactory: (slug) => `/fr/formateurs/${slug}`,
    trainingPathFactory: (slug) => `/fr/formation/${slug}`,
    microsoftTrainingPath: `/fr/formation/catalogue/microsoft`,
    awsTrainingPath: `/fr/formation/catalogue/aws`,
    icfTrainingPath: `/fr/coaching-professionnel`,
    pmiTrainingPath: `/fr/formation/catalogue/strategie-operations/gestion-de-projet`,
    leanTrainingPath: `/fr/formation/catalogue/strategie-operations/methodologies-lean`,
    comptiaTrainingPath: `/fr/formation/catalogue/comptia`,
    vmwareTrainingPath: `/fr/formation/catalogue/vmware`,
    ciscoTrainingPath: `/fr/formation/catalogue/cisco`,
    itilTrainingPath: `/fr/formation/catalogue/itil`,
    scaleTrainingPath: `/fr/formation/catalogue/scale-agile`,
    vivreAfiUPath: `/fr/vivre-afiu`,
    contactPath: `https://lp.afiexpertise.com/contactez-nous-afiu`,
  },
}
